import { takeLatest, call, put } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  fetchCouponsRequest,
  fetchCouponsSuccess,
  fetchCouponsFailure,
  createCouponRequest,
  createCouponSuccess,
  createCouponFailure,
  updateCouponRequest,
  updateCouponSuccess,
  updateCouponFailure,
  deleteCouponRequest,
  deleteCouponSuccess,
  deleteCouponFailure,
  getApplicableCouponsRequest,
  getApplicableCouponsSuccess,
  getApplicableCouponsFailure,

  purchaseCouponRequest,
  purchaseCouponSuccess,
  purchaseCouponFailure,
  checkPaymentStatusRequest,
  checkPaymentStatusSuccess,
  checkPaymentStatusFailure,
  checkActiveCouponRequest,
  checkActiveCouponSuccess,
  checkActiveCouponFailure,
  clearCouponError,
  clearCouponInfo
} from "./CouponSlice";

// GET ALL COUPONS
function* fetchCouponsWorker(action) {
  try {
    const { page, limit, search } = action.payload || {};
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/coupon/list`,
       {
        params: {
          page,
          limit,
          search,
        },
      }
    );
    console.log("response in coupan",response.data.data)
     yield put(
      fetchCouponsSuccess({
        data: response.data.data,
        total: response.data.total,
      })
    );
  } catch (error) {
    yield put(fetchCouponsFailure(error.message));
    toast.error("Failed to load coupons");
  }
}

// CREATE COUPON
function* createCouponWorker(action) {
  try {
    const response = yield call(
      axios.post,
     `${process.env.REACT_APP_API_BASE_URL}/api/v1/coupon/create`,
      action.payload
    );
    if (response.data.success) {
      toast.success(response.data.message);
      yield put(fetchCouponsRequest());
      return;
    }
    toast.error(response.data.message);
  } catch (error) {
    yield put(createCouponFailure(error.message));
    toast.error("Failed to create coupon");
  }
}

// PURCHASE COUPON
// function* purchaseCouponWorker(action) {
//   try {
//     const response = yield call(
//       axios.post,
//       `${process.env.REACT_APP_API_BASE_URL}/api/v1/coupon/purchase`,
//       action.payload
//     );
//     if (response.data.success) {
//       window.open(`/cashfree/${response.data.data.token}/${response.data.data.orderId}`, "_self");
//       return;
//     }
//     toast.error(response.data.message);
//   } catch (error) {
//     toast.error(error.message);
//   }
// }

// UPDATE COUPON
function* updateCouponWorker(action) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/coupon/update`,
      action.payload
    );
    if (response.data.success) {
      toast.success(response.data.message);
      yield put(fetchCouponsRequest());
      return;
    }
    toast.error(response.data.message);
  } catch (error) {
    yield put(updateCouponFailure(error.message));
    toast.error("Failed to update coupon");
  }
}

// DELETE COUPON
function* deleteCouponWorker(action) {
  try {
    yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/coupon/delete/${action.payload}`
    );
     // Dispatch delete success
    yield put(deleteCouponSuccess(action.payload));

    // Refetch coupons
    yield put(fetchCouponsRequest());
    toast.success("Coupon deleted successfully");
  } catch (error) {
    yield put(deleteCouponFailure(error.message));
    toast.error("Failed to delete coupon");
  }
}
function* getApplicableCouponsWorker(action) {
  try {
    // action.payload can be filters (e.g., jewellerId, productCategory)
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/coupon/applicable/${action.payload}`,
    );
    
    if (response.data.success) {
      yield put(getApplicableCouponsSuccess(response.data.data));
        toast.success(response.data.message)
    } else {
      yield put(getApplicableCouponsFailure(response.data.message));
      yield put( clearCouponError());   // clear redux error
    yield put (clearCouponInfo());   // clear coupon info
      toast.error(response.data.message);
    }
  } catch (error) {
    yield put(getApplicableCouponsFailure(error.message));
    toast.error("Failed to fetch applicable coupons");
  }
}


// CHECK PAYMENT STATUS
// function* checkPaymentStatusWorker(action) {
//   const { orderId } = action.payload;
//   try {
//     const response = yield call(
//       axios.get,
//       `${process.env.REACT_APP_API_BASE_URL}/api/v1/coupon/checkpaymentstatus/${orderId}`
//     );
//     if (response.data.success) {
//       toast.success("Coupon has been purchased successfully");
//       window.open("/Coupons", "_self");
//       return;
//     } else {
//       toast.error(response.data.message);
//       window.open("/Coupons", "_self");
//       return;
//     }
//   } catch (error) {
//     yield put(checkPaymentStatusFailure(error.message));
//     toast.error("Failed to check payment status");
//   }
// }

// CHECK ACTIVE COUPON
// function* checkActiveCouponWorker() {
//   const response = yield call(
//     axios.get,
//     `${process.env.REACT_APP_API_BASE_URL}/api/v1/coupon/active`
//   );
//   if (response.data.success) {
//     yield put(checkActiveCouponSuccess(response.data.data));
//   }
// }

// WATCHER
export function* watchCouponSaga() {
  yield takeLatest(fetchCouponsRequest.type, fetchCouponsWorker);
  yield takeLatest(createCouponRequest.type, createCouponWorker);
  yield takeLatest(updateCouponRequest.type, updateCouponWorker);
  yield takeLatest(deleteCouponRequest.type, deleteCouponWorker);
  yield takeLatest(getApplicableCouponsRequest.type, getApplicableCouponsWorker); 

//   yield takeLatest(purchaseCouponRequest.type, purchaseCouponWorker);
//   yield takeLatest(checkPaymentStatusRequest.type, checkPaymentStatusWorker);
//   yield takeLatest(checkActiveCouponRequest.type, checkActiveCouponWorker);
}
